<script setup lang="ts">
const $props = defineProps<{
  href: string;
  target?: string;
  rel?: string;
  class?: string;
  style?: string;
  title?: string;
  icon?: string;
}>();
</script>

<template>
  <a v-bind="$props" :class="$props.class" :style="$props.style" :title="$props.title">
    <slot />
  </a>
</template>

<style scoped lang="sass">
a
  color: $blue-8
  font-weight: 600
  text-decoration: none
  position: relative

  &:before
    content: ""
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    height: 2px
    background-color: $blue
    transform: scaleX(0)
    transition: transform 0.3s ease-in-out

  &:hover:before
    transform: scaleX(1)
</style>
